window.sumZero = window.sumZero || {};

sumZero.titleize = function(string) {
	// Unrelated site note but these regexes and string replacers look like <em>GOOF-TACULAR</em> emoji
	if (typeof(string) === 'string') {
		return string.replace(/^(.)|_(.)/g, text => text.replace('_', ' ').toUpperCase());
	}
};